import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  InputItem,
  List,
  WhiteSpace,
  Button,
  Toast,
  Picker,
} from "antd-mobile-v2";
import "./index.less";
import { GenderData } from "./const";
import { createForm } from "rc-form";
import { get, headerGet, post } from "../../api/service/services";
import tool from "../../api/tool";
import { getQuestion } from "../../public/getQuestion";
import sectioValue from "../../api/service/secsstion";
import allUrl from "../../api/allUrl";
const Item = List.Item;
class EditSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      imageKey: {},
      questionData: [], // 密保问题数据
    };
  }
  componentDidMount() {
    this.getImageCode();
    this.getQuestion();
  }
  // 获取密保问题数据
  getQuestion = async () => {
    let toolData = tool.get("questionData");
    // 判断密保问题数据有没有存，如果有就用已经存的，如果没有就重新请求
    if (toolData && toolData.length) {
      this.setState({ questionData: toolData });
      return;
    }
    let data = await getQuestion();
    tool.set("questionData", data);
    this.setState({ questionData: data });
  };
  // 获取图片验证码
  getImageCode = () => {
    get(allUrl.register.getImageCode, {})
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let imgKey = res.data.key || "";
          let imageUrl = res.data.image || "";
          this.setState({
            imageKey: {
              imageKey: imgKey,
              imageUrl: imageUrl,
            },
          });
        } else {
          Toast.info(res.data.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info("验证码获取失败，请重试", 1);
      });
  };
  // 数据提交
  onSubmit = () => {
    const { questionData } = this.state;
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      let questionName = questionData.filter((item) => {
        return item.value == values["pwdQuestionOne"][0];
      });
      values["pwdQuestionOne"] = questionName[0].label;
      values["userCode"] = sectioValue.get("acount");
      this.submitData(values);
    });
  };
  submitData = (values) => {
    post(allUrl.register.updateQuestion, values, {
      "Content-Type": "application/json;charset=UTF-8",
      "Captcha-Code": this.props.form.getFieldValue("imageCode"),
      "Captcha-Key": this.state.imageKey.imageKey,
    })
      .then((res) => {
        if (res.success == true && res.code == 200) {
          Toast.success("密保修改成功", 1, () => {
            this.props.history.push("/home");
          });
        } else {
          Toast.info(res.msg, 1, () => {
            this.getImageCode();
          });
        }
      })
      .catch((error) => {
        if (error && error.data && error.data.msg) {
          Toast.info(error.data.msg, 1, () => {
            this.getImageCode();
          });
        } else {
          Toast.info("提交失败", 1, () => {
            this.getImageCode();
          });
        }
      });
  };
  render() {
    const { flagCode, count } = this.state;
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div className="EditSecurity-wrapper">
        <form>
          <List>
            <InputItem
              {...getFieldProps("newPassWordVerify", {
                // initialValue: 'little ant',
                rules: [
                  { required: true, message: "请输入登录密码" },
                  {
                    required: false,
                    pattern: new RegExp(
                      /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                      "g"
                    ),
                    message: "请输入正确的密码",
                  },
                ],
              })}
              clear
              type="password"
              error={!!getFieldError("newPassWordVerify")}
              placeholder="请输入登录密码"
            >
              登录密码
            </InputItem>
            <Picker
              data={this.state.questionData}
              cols={1}
              {...getFieldProps("pwdQuestionOne", {
                initialValue: "",
                rules: [{ required: true, message: "请选择密保问题" }],
              })}
              title="选择密保问题"
            >
              <List.Item arrow="horizontal">密保问题</List.Item>
            </Picker>
            <InputItem
              {...getFieldProps("pwdAnswerOne", {
                // initialValue: 'little ant',
                rules: [{ required: true, message: "请输入密保答案" }],
              })}
              clear
              error={!!getFieldError("pwdAnswerOne")}
              onErrorClick={() => {
                alert(getFieldError("pwdAnswerOne").join("、"));
              }}
              placeholder="请输入密保答案"
            >
              密保答案
            </InputItem>
            <div className="item-cont">
              <InputItem
                {...getFieldProps("imageCode", {
                  rules: [{ required: true, message: "请输入图片验证码" }],
                })}
                placeholder="请输入图片验证码"
                type=""
                labelNumber={6}
              >
                图片验证码
              </InputItem>
              <div
                className="code-image"
                onClick={() => {
                  this.getImageCode();
                }}
              >
                <img src={this.state.imageKey.imageUrl || ""}></img>
              </div>
            </div>
          </List>
        </form>
        <div
          style={{
            padding: "0 0.1rem",
            position: "absolute",
            left: "0",
            bottom: "0.2rem",
            width: "100%",
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              this.onSubmit();
            }}
          >
            提交
          </Button>
        </div>
      </div>
    );
  }
}
export default createForm()(EditSecurity);
